<template>
    <div class="post-form">
        <div>
            <div class="vx-row mb-6 ">
                <div class="vx-col w-full">
                    <p class="form-label text-14 font-medium leading-1-43">Company Name</p>
                    <vs-input v-validate="'required'" name="company_name" v-model="postJobs.companyName" class="w-full form-label text-onyx-lightest" maxlength="50" />
                    <span class="text-danger text-xs" v-show="errors.has('company_name')">{{ errors.first('company_name') }}</span>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <p class="form-label text-14 font-medium leading-1-43">First Name</p>
                    <vs-input v-validate="{ required: true, is_not: postJobs.lastName }" name="first_name" v-model="postJobs.firstName" class="w-full form-label text-onyx-lightest" maxlength="50" />
                    <span class="text-danger text-xs" v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
                </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                  <p class="form-label text-14 font-medium leading-1-43">Last Name</p>
                  <vs-input v-validate="{ required: true, is_not: postJobs.firstName }" name="last_name" v-model="postJobs.lastName" class="w-full form-label text-onyx-lightest" maxlength="50" />
                  <span class="text-danger text-xs" v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
              </div>
          </div>
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <p class="form-label text-14 font-medium leading-1-43">Work Email</p>
                    <vs-input v-validate="'required|email'" name="email" v-model="postJobs.email" class="w-full form-label text-onyx-lightest" type="email" />
                    <span class="text-danger text-xs" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <p class="form-label text-14 font-medium leading-1-43">Phone Number</p>
                    <vs-input v-validate="'required|regex:^\\([0-9]{3}\\)\\s[0-9]{3}-[0-9]{4}$'" name="phone_number" @keyup="formatPhoneNumber" v-model="postJobs.phoneNumber" class="w-full form-label text-onyx-lightest" maxlength="14" @input="setDirty('phone_number')" />
                    <span class="text-danger text-xs"  v-show="isErrorVisible('phone_number')">{{ getErrorMessage('phone_number') }}</span>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <p class="form-label text-14 font-medium leading-1-43">Number of hires needed in the next 60 days?</p>
                    <v-select
                        name="monthly_recruitment_needs"
                        data-vv-name="monthly_recruitment_needs"
                        v-validate="'required'"
                        :options="['1-2','3-5','6-10','11-25','26-50','51-100','100+']"
                        v-model="postJobs.recruitmentNeeds"
                        placeholder="Select hire needs"
                    />
                    <span class="text-danger text-xs" v-show="errors.has('monthly_recruitment_needs')">
                    {{ errors.first('monthly_recruitment_needs') }}
                    </span>
                    <input type="hidden" name="monthly_recruitment_needs" :value="postJobs.recruitmentNeeds" />
                </div>
            </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <p class="form-label text-14 font-medium leading-1-43">Any details you would like to share?</p>
              <vs-textarea name="additional_details" v-model="postJobs.additionalDetails" class="w-full form-label text-onyx-lightest" />
            </div>
          </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <p class="text-10">
                    This site is protected by reCAPTCHA and the Google
                    <a class="text-primary" target="_blank" rel="noopener noreferrer" href="https://policies.google.com/privacy">Privacy Policy</a>  and
                    <a class="text-primary" target="_blank" rel="noopener noreferrer" href=" https://policies.google.com/terms">Terms of Service</a> apply.
                </p>
              </div>
            </div>
            <div class="flex flex-col-reverse md:flex-row md:items-center md:justify-between">
                <div class="vx-col w-full">
                    <vs-button size="large" class="w-full" @click="submitForm" :title="buttontext">
                      <span class="font-medium">{{ buttontext }}</span>
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Validator } from 'vee-validate';
    import FormatPhoneNumberMixin from "../../mixins/FormatPhoneNumberMixin";
    import HandleBackEndErrorsMixin from "../../mixins/HandleBackEndErrorsMixin";
    import 'vue-select/dist/vue-select.css'

    export default {

        mixins: [
            FormatPhoneNumberMixin,
            HandleBackEndErrorsMixin
        ],
        props: {
            formData: {
                type: [Array, Object]
            },
            heading : {
                type: String,
                default : ''
            },
            subheading : {
                type: String,
                default : ''
            },
            buttontext : {
                type: String,
                default : ''
            },
        },
        data() {
            return {
                postJobs: {
                    // post jobs
                    companyName: this.formData['company_name'] || '',
                    firstName: this.formData['first_name'] || '',
                    lastName: this.formData['last_name'] || '',
                    email: this.formData['email'] || '',
                    phoneNumber: this.formData['phone_number'] || '',
                    recruitmentNeeds: this.formData['monthly_recruitment_needs'] || '',
                    additionalDetails : this.formData['additional_details'] || ''
                }
            }
        },

        created() {
            let dict = {
                custom: {
                    company_name: {
                        required: 'Company Name is required'
                    },
                    first_name: {
                        required: 'First Name is required',
                        is_not: 'First Name must be different from Last Name',
                    },
                    last_name: {
                        required: 'Last Name is required',
                        is_not: 'Last Name must be different from First Name',
                    },
                    email: {
                        required: 'Email is required',
                        email: 'Email format invalid'
                    },
                    phone_number: {
                        required: 'Mobile Phone is required',
                        regex: 'Mobile Phone is invalid'
                    },
                    monthly_recruitment_needs: {
                        required: 'Monthly Recruitment Needs is required'
                    },
                }
            };

            // register custom messages
            Validator.localize('en', dict);
        },

        methods: {
            formatPhoneNumber(ev) {
                this.postJobs.phoneNumber = this.setFormatPhoneNumber(ev, this.postJobs.phoneNumber);
            },

            submitForm() {
                this.$validator
                    .validate()
                    .then( success => {
                        if (!success) {
                            return;
                        }
                        this.$parent.$refs.form.submit();
                    });
            }
        }
    }
</script>
